import { faqs } from '@/mocks/home';

export default function FAQ() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-primary-100/70 text-primary-700 text-xs font-medium px-3 py-1 rounded-full mb-4">
            <i className="ri-question-line text-xs"></i>
            <span>帮助中心</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            快速了解古古漫画网的使用方式和核心功能
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="space-y-3 md:space-y-4">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="bg-background-100 border border-background-200/70 rounded-lg p-5 md:p-6 hover:border-primary-200/40 transition-colors"
              >
                <h3 className="flex items-start gap-3 text-foreground-900 font-medium text-sm md:text-base mb-3">
                  <span className="text-primary-500 shrink-0 font-heading text-lg mt-0.5 leading-none">Q</span>
                  <span>{faq.q}</span>
                </h3>
                <div className="flex items-start gap-3">
                  <span className="text-accent-500 shrink-0 font-heading text-lg mt-0.5 leading-none">A</span>
                  <p className="text-foreground-500 text-sm leading-relaxed">{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}